<template>
<m-pageframe
    title="{organization_label}: Order Attribution Analytics"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>
    <m-edit-time-period
        v-model="analytics_time_period"
    />


    <m-edit-text
        label="Attribution Proximity (Days)"
        v-model="param_time_prox_days"
        v-on:input="doUpdate"
        integer
        read_only
    />

    <m-select-order-type
        v-model="order_types"
        v-on:input="doUpdate"
        read_only
    />

    <m-chart-time-series
      series="order-attribution-total-value"
      :period="analytics_time_period"
    />

    <m-chart-time-series
      series="order-attribution-total-value"
      chart_type="donut"
      :period="analytics_time_period"
    />
    

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

  data() {
    return {
      analytics_time_period: null,
      order_types: [],
      param_time_prox_days: 30,  
    }
  },

  mounted () {
    this.update();
  },

  methods: {
    update() {
        this.$rc.rest({
            'spinner': false,
            'endpoint': 'GET: /api/v1/organizations/order-attribution-settings/:organization_id',
        
            'params' : {
                    'organization_id': this.$route.params.organization_id
                },
        
            'on_success': (data) => {
                    this.order_types = data.include_order_types;
                    this.param_time_prox_days = data.attribution_proximity_days;
                },
        
            'on_error': 'Unable to complete API call',
        });
    }
  },
  
}
</script>

<style lang="scss" scoped>
</style>